import React from 'react';
import classNames from 'classnames';
import { omit } from 'lodash';
import styles from './icon-button.scss';

type Props = {
  component?: React.ElementType;
  className?: string;
  icon: React.ComponentType<{ className?: string }>;
  iconClassName?: string;
  label?: string;
  children?: React.ReactNode;
} & React.HTMLAttributes<HTMLElement>;

const IconButton = ({
  component: Component = 'button',
  className,
  icon: Icon,
  iconClassName,
  label,
  children,
  ...props
}: Props) => {
  const componentProps = omit(props, ['tReady', 'lng']);

  return (
    <Component className={classNames(styles.button, className)} {...componentProps}>
      <span className={styles.wrapper}>
        <Icon className={iconClassName} />
        <span className={styles.label}>{label}</span>
      </span>
      {children}
    </Component>
  );
};

export default IconButton;
